module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAfCAYAAABgfwTIAAAAl0lEQVRYhe3VMQ5BURCG0fNuxA6U3jpEo2EfEpZlJShoXqzDLlBQ0HiRGNVVzEmm/5Ip/qYbjVtsMMNQPVccsW660XiHecWYvkPBpHZFz7TgVLuipytYYe/505pur47lAGcs6va8K7UDPsmoqIyKyqioghZbXHCveJdXR5uDHJSD/E0O8s8yKiqjojIqKgc5KAc56j8H+QHYh2ZedhWY+gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/home/1-2.png
// module id = nxVb
// module chunks = 15